import { Box, Text } from '@a1s/ui';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useSearchContext } from '../../screens/Search/lib/searchContext';

import { Loader } from 'ui-new';

//
// Main component
// -------------------------------------------------------------------------------------------------

interface Props {
  image?: string;
  loading?: boolean;
}

export function DetectionEmailPreview({ image, loading }: Props) {
  const { userPermitted } = useSearchContext();
  const { t } = useTranslation('unisearch');

  // Early return is user doesn't have permissions
  if (!userPermitted)
    return (
      <Text font="sans" size="sm" stretch="ultraCondensed">
        {t('components:NoAccess.needAccessFromAdmin')}
      </Text>
    );

  if (loading) return <Loader />;

  if (!image)
    return (
      <Text font="sans" size="sm" stretch="ultraCondensed">
        {t('screenshotUnavailable')}
      </Text>
    );

  return (
    <Box css={{ maxWidth: '100%', '& > img': { width: '100%' } }} data-testid="detection-email-preview">
      <img alt={t('emailPreview')} src={`data:image/png;base64,${image}`} />
    </Box>
  );
}
